import React from "react";

import SkillTextService from "../../services/SkillTextService";

import "./agent-skill-body.css";

class AgentSkillBody extends React.PureComponent {
	renderSpans({ spans }) {
		return spans.map((span, index) => (span.isBold ? <strong key={index}>{span.text}</strong> : <React.Fragment key={index}>{span.text}</React.Fragment>));
	}

	renderListItems({ items }) {
		return items.map((item, index) => (
			<li key={index}>
				{this.renderSpans({ spans: item.spans })}
				{item.details.length > 0 && (
					<div className="agent-skill-body__details">
						{item.details.map((spans, detailIndex) => (
							<div key={detailIndex} className="agent-skill-body__detail">
								{this.renderSpans({ spans })}
							</div>
						))}
					</div>
				)}
			</li>
		));
	}

	renderBlock = (block, index) => {
		if (block.kind === "heading") {
			const HeadingTag = `h${block.level + 2}`;
			return (
				<HeadingTag key={index} className={`agent-skill-body__heading agent-skill-body__heading--${block.level}`}>
					{this.renderSpans({ spans: block.spans })}
				</HeadingTag>
			);
		}
		if (block.kind === "bullets") {
			return (
				<ul key={index} className="agent-skill-body__list">
					{this.renderListItems({ items: block.items })}
				</ul>
			);
		}
		if (block.kind === "numbered") {
			return (
				<ol key={index} className="agent-skill-body__list" start={block.start}>
					{this.renderListItems({ items: block.items })}
				</ol>
			);
		}
		if (block.kind === "fenced") {
			return (
				<pre key={index} className="agent-skill-body__fenced">
					{block.text}
				</pre>
			);
		}
		return (
			<p key={index} className="agent-skill-body__paragraph">
				{this.renderSpans({ spans: block.spans })}
			</p>
		);
	};

	render() {
		const { body, pageTitle } = this.props;
		const blocks = SkillTextService.readableBlocksOfSkill({ body });
		if (blocks.length === 0) return <div className="tk-muted">This skill has no instructions yet.</div>;
		const shownBlocks = SkillTextService.blocksWithoutRepeatedTitle({ blocks, pageTitle });
		return <div className="agent-skill-body">{shownBlocks.map(this.renderBlock)}</div>;
	}
}

export default AgentSkillBody;
